import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api from "../api";
import { company } from "../mock";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, redirect_to: `${window.location.origin}/reset-password` });
      setSent(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <div className="absolute inset-0 dot-grid opacity-60" />
      <div className="relative w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-xl shadow-slate-200/60">
        <div className="mb-6 flex items-center gap-3">
          <img src={company.logo} alt={company.legal} className="h-10 w-10 rounded-lg object-cover" />
          <div className="text-sm font-bold text-slate-900">{company.name}</div>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="text-center">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-50">
              <MailCheck className="h-6 w-6 text-emerald-600" />
            </div>
            <h2 className="mt-4 text-2xl font-bold text-slate-900">Check Your Email</h2>
            <p className="mt-2 text-sm text-slate-500">
              If an account exists for this email address, a password reset link has been sent. The link expires shortly — request another if it stops working.
            </p>
            <Link to="/" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-violet-600 hover:underline">
              <ArrowLeft className="h-4 w-4" /> Back to Login
            </Link>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-slate-900">Reset Your Password</h2>
            <p className="mt-1 text-sm text-slate-500">
              Enter the email address associated with your Campbell Connect account and we'll send you a password reset link.
            </p>
            {error && <div className="mt-4 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email address</Label>
                <Input id="email" data-testid="forgot-email-input" type="email" placeholder="you@campbellcomm.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <Button type="submit" disabled={busy} data-testid="send-reset-link-btn" className="btn-primary-gradient w-full border-0 text-white">
                {busy ? "Sending…" : "Send Reset Link"}
              </Button>
            </form>
            <Link to="/" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-violet-600 hover:underline">
              <ArrowLeft className="h-4 w-4" /> Back to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
